import { render, staticRenderFns } from "./ytComment.vue?vue&type=template&id=11b4c737&scoped=true"
import script from "./ytComment.vue?vue&type=script&lang=js"
export * from "./ytComment.vue?vue&type=script&lang=js"
import style0 from "./ytComment.vue?vue&type=style&index=0&id=11b4c737&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11b4c737",
  null
  
)

export default component.exports